import { render, staticRenderFns } from "./FeedNewItemsBadge.vue?vue&type=template&id=bc7630cc&"
import script from "./FeedNewItemsBadge.vue?vue&type=script&lang=js&"
export * from "./FeedNewItemsBadge.vue?vue&type=script&lang=js&"
import style0 from "./FeedNewItemsBadge.vue?vue&type=style&index=0&id=bc7630cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports